import { useState } from 'react'

import { Wrapper, VideoName, StyledBase64Image, ImageWrapper, FavoriteIcon, VideoInfo } from './Styled'
import { useNavigateTo } from 'hooks/useNavigateTo'
import useNavigateToShortVideo from 'hooks/useNavigateToShortVideo'

interface NormalVideoInfo {
  videoInfo: any
  columns?: number
  width?: string
  shortInfo?: undefined
  overflow?: any
  noTitle?: boolean
  textAlign?: string
  allowUnload?: boolean
  noLazy?: boolean
  [key: string]: any
}

interface ShortVideoInfo {
  videoInfo: any
  columns?: number
  width?: string
  shortInfo: { list: object[] }
  overflow?: any
  noTitle?: boolean
  textAlign?: string
  allowUnload?: boolean
  noLazy?: boolean
  [key: string]: any
}

type Props = NormalVideoInfo | ShortVideoInfo

/**
 * 元件 - 個人中心短視頻影片 Item
 */
export default function ShortVideoBox({
  videoInfo,
  width,
  columns = 2,
  shortInfo,
  overflow,
  noTitle,
  textAlign = 'left',
  allowUnload = false,
  noLazy,
  ...props
}: Props) {
  // const hasPayment = useHasPayment()
  // const isVideo = shortInfo == null
  const { navigateToViewVideo } = useNavigateTo()
  const { navigateToViewShortWithPartVideoCheck } = useNavigateToShortVideo()

  const { title, coverphoto_v } = videoInfo

  const [base64Img, setBase64Img] = useState<string | undefined>()

  const onVideoBoxClick = () => {
    // 使用是否有短視頻資訊來判斷要跳轉哪個頁面
    if (shortInfo == null) {
      navigateToViewVideo({
        ...videoInfo,
        posterImg: `data:image/jpeg;base64, ${base64Img}`,
      })
    } else {
      navigateToViewShortWithPartVideoCheck({
        videoList: shortInfo.list,
        videoInfo,
        posterImg: `data:image/jpeg;base64, ${base64Img}`,
      })
    }
  }

  return (
    <Wrapper {...props} onClick={onVideoBoxClick} width={width} columns={columns}>
      <ImageWrapper>
        <StyledBase64Image
          overflow={overflow}
          aspectRatio={1 / 1.414}
          src={coverphoto_v}
          onBase64ImageLoad={setBase64Img}
          noLazy={noLazy}
          allowUnload={allowUnload}
        />
        <VideoInfo>
          <FavoriteIcon></FavoriteIcon>
          {videoInfo.like_count}
        </VideoInfo>
      </ImageWrapper>
      {!noTitle && <VideoName textAlign={textAlign}>{title}</VideoName>}
    </Wrapper>
  )
}
